import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { LayoutState } from '../../../core/layout.state';

@Component({
  selector: 'app-logo',
  imports: [],
  templateUrl: './logo.html',
  styleUrl: './logo.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Logo {
  #store = inject(Store);

  isXsm$ = this.#store.selectSignal(LayoutState.isXsm);
  isMd$ = this.#store.selectSignal(LayoutState.isMd);
}
